export default "__VITE_ASSET__16e152e8__"